export default __webpack_public_path__ + "static/d-feature-3-2073e05363298ff86ac220256025d84a.png";